import { Col, Collapse, Row } from "antd";
import React, { useState } from "react";
import TagComponent from "../../../../biblio/TagComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { DeleteOutlined } from "@ant-design/icons";
import CancelProgramRequest from "./CancelProgramRequest";
import dayjs from "dayjs";
interface ProgramListRequestProps {
  requests: any;
}
const ProgramListRequest = ({ requests }: ProgramListRequestProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState<any>();
  return (
    <div
      className="takaful--collapse-profile-container"
      style={{ marginTop: "2rem" }}
    >
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{
                  marginBottom: "0",
                  // , paddingLeft: "2.6rem"
                }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الترشح
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الترشح
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={7}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    البرنامج
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  // style={{ paddingRight: "1.6rem" }}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  // justify={"space-between"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      رقم الترشح
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ الترشح
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.date
                        ? dayjs(element?.date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    البرنامج 
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.program_name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                    المرحلة 
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={10}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      width="70%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={element?.stage_id}
                      className="takaful--tag-component"
                    />
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={10}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    {element?.has_cancel_request === false && (
                      <PrimaryButton
                        className="takaful--delete-program-button"
                        title="إلغاء"
                        icon={<DeleteOutlined />}
                        onClick={(event: any) => {
                          event.stopPropagation();
                          setSelectedId(element?.id);
                          setIsModalVisible(true);
                        }}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            }
          >
            <div style={{ padding: "0rem 1rem 0rem 1rem" }}>
              <Row
                className={`takaful--content-profile-box1`}
                justify={"space-between"}
              >
                <Col
                  xxl={4}
                  xl={4}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المستفيد
                  </p>
                </Col>
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={12}
                  className="takaful--content-profile-col "
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.partner_id}
                  </span>
                </Col>
                <Col xxl={6} xl={6} lg={6} md={6} sm={0} xs={0} />
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={18}
                  xs={18}
                  className="takaful--content-profile-col"
                >
                  {element?.is_excluded === true ? (
                    <TagComponent
                      className="takaful--tag-component"
                      width="70%"
                      state={"cancel"}
                      redValue="cancel"
                      text={"موقوف عن البرنامج"}
                    />
                  ) : null}
                </Col>
              </Row>
              {element?.total_marks > 0 ? (
                element?.award !== false ? (
                  <Row
                    justify={"space-between"}
                    className={`takaful--content-profile-box1`}
                  >
                    <Col
                      xxl={4}
                      xl={4}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        علامة التقييم
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.total_marks}
                      </span>
                    </Col>

                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        الجائزة
                      </p>
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.award}
                      </span>
                    </Col>
                  </Row>
                ) : (
                  <Row
                    justify={"space-between"}
                    className={`takaful--content-profile-box1`}
                  >
                    <Col
                      xxl={4}
                      xl={4}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <p className="takaful--content-services-request-p">
                        علامة التقييم
                      </p>
                    </Col>
                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    >
                      <span className="takaful--content-services-request-span takaful--color-span">
                        {element?.total_marks}
                      </span>
                    </Col>

                    <Col
                      xxl={6}
                      xl={6}
                      lg={6}
                      md={6}
                      sm={12}
                      xs={12}
                      className="takaful--content-profile-col"
                    />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} />
                  </Row>
                )
              ) : element?.award !== false ? (
                <Row
                  justify={"space-between"}
                  className={`takaful--content-profile-box1`}
                >
                  <Col
                    xxl={4}
                    xl={4}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      الجائزة
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.award}
                    </span>
                  </Col>

                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  />
                  <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12} />
                </Row>
              ) : null}

              {element?.is_excluded === true && (
                <Row
                  className={`takaful--content-profile-box1`}
                  justify={"space-between"}
                >
                  <Col
                    xxl={4}
                    xl={4}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ الإيقاف
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span takaful--date-format">
                      {element?.exclude_application_date}
                    </span>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      سبب الإيقاف
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span">
                      {element?.exclude_application_reason}
                    </span>
                  </Col>
                </Row>
              )}
              {element?.refuse_reason && (
                <Row
                  className={`takaful--content-profile-box1`}
                  justify={"space-between"}
                >
                  <Col
                    xxl={4}
                    xl={4}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      سبب الرفض
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span takaful--color-span takaful--date-format">
                      {element?.refuse_reason}
                    </span>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  ></Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  ></Col>
                </Row>
              )}
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
      <CancelProgramRequest
        programId={selectedId}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </div>
  );
};

export default ProgramListRequest;
